/** localStorage key BookingFlowContext keeps the booking-flow session id under
 *  (`{ sessionId, timestamp }`). The id is stamped on the checkout cart's
 *  `session_id`, and a guest's cart is reached by it (src/api/cartStore.js). */
export const BOOKING_SESSION_STORAGE_KEY = 'defera_booking_session';

/** The stored booking-flow session id, or null. Never throws. */
export function readStoredBookingSessionId() {
  try {
    const stored = globalThis.localStorage?.getItem(BOOKING_SESSION_STORAGE_KEY);
    if (!stored) return null;
    const sessionId = JSON.parse(stored)?.sessionId;
    return typeof sessionId === 'string' && sessionId ? sessionId : null;
  } catch {
    return null;
  }
}
